"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const ScriptLoader_1 = __importDefault(require("./ScriptLoader"));
// doc => http://v.qq.com/open/doc/tvpapi2.0.pdf (chinese only)
const tvpAPI = 'https://imgcache.qq.com/tencentvideo_v1/tvp/js/tvp.player_v2.js';
class TencentPlayerMod extends react_1.default.Component {
    render() {
        const elementId = `tencent-video-${this.props.videoId}`;
        return react_1.default.createElement("div", { id: elementId, className: "tencent-video-embed" });
    }
}
TencentPlayerMod.propTypes = {
    videoId: prop_types_1.default.string
};
/* eslint react/no-multi-comp: 0 */
class TencentVideoEmbed extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.apiLoadedCallBack = this._apiLoadedCallBack.bind(this);
    }
    componentWillUnmount() {
        window_or_global_1.default.tvp.playerInited = false; // remove init flag before unmounting
    }
    _apiLoadedCallBack() {
        const { tvp } = window_or_global_1.default;
        tvp.report = () => {
            return true;
        }; // TON-39499 override tvp.report method to suppress error casued in IE 11
        if (!window_or_global_1.default.tvp.playerInited) {
            window_or_global_1.default.tvp.playerInited = true;
            const mountId = `tencent-video-${this.props.videoId}`;
            const videoEleId = `tvp-${this.props.videoId}`;
            const video = new tvp.VideoInfo();
            video.setVid(this.props.videoId);
            this.player = new tvp.Player();
            this.player.create({
                playerid: videoEleId,
                video,
                modId: mountId,
                autoplay: true,
                html5loop: true,
                playerType: 'html5',
                isContinuePlay: false,
                onplaying: () => {
                    // a hack to mute video
                    const myVideo = window_or_global_1.default.document.getElementById(videoEleId);
                    myVideo.muted = true;
                }
            });
        }
    }
    render() {
        const ScriptLoaderWrapper = (0, ScriptLoader_1.default)(TencentPlayerMod, tvpAPI);
        return (react_1.default.createElement(ScriptLoaderWrapper, { videoId: this.props.videoId, asyncScriptOnLoad: this.apiLoadedCallBack }));
    }
}
exports.default = TencentVideoEmbed;
TencentVideoEmbed.propTypes = {
    videoId: prop_types_1.default.string
};
//# sourceMappingURL=TencentVideoEmbed.js.map